import React from 'react';

// NOTE: v1 placeholder artwork. Designer pass pending.
export default function SummerAccessory() {
  return (
    <g aria-hidden="true">
      {/* Big sun upper-left with smile */}
      <circle cx="40" cy="48" r="20" fill="#E5B941" />
      <g stroke="#E5B941" strokeWidth="4" strokeLinecap="round">
        <line x1="40" y1="18" x2="40" y2="6" />
        <line x1="40" y1="78" x2="40" y2="90" />
        <line x1="10" y1="48" x2="-2" y2="48" />
        <line x1="70" y1="48" x2="82" y2="48" />
        <line x1="19" y1="27" x2="11" y2="19" />
        <line x1="61" y1="27" x2="69" y2="19" />
        <line x1="19" y1="69" x2="11" y2="77" />
        <line x1="61" y1="69" x2="69" y2="77" />
      </g>
      <circle cx="34" cy="45" r="1.5" fill="#131313" />
      <circle cx="46" cy="45" r="1.5" fill="#131313" />
      <path d="M33,52 Q40,57 47,52" stroke="#131313" strokeWidth="1.5" fill="none" strokeLinecap="round" />
      {/* Bucket on roof */}
      <path d="M86,72 L82,96 L106,96 L102,72 Z" fill="#E0290A" />
      <ellipse cx="94" cy="72" rx="9" ry="2.5" fill="#a51f08" />
      <ellipse cx="94" cy="72" rx="7" ry="1.5" fill="#131313" opacity="0.4" />
      <path d="M85,72 Q94,60 103,72" stroke="#E5B941" strokeWidth="2" fill="none" />
      <line x1="90" y1="76" x2="89" y2="92" stroke="#a51f08" strokeWidth="1" opacity="0.7" />
      <line x1="98" y1="76" x2="99" y2="92" stroke="#a51f08" strokeWidth="1" opacity="0.7" />
      {/* Spade leaning against bucket */}
      <rect x="110" y="58" width="4" height="30" fill="#CD7F32" transform="rotate(18 112 73)" />
      <ellipse cx="115" cy="56" rx="4" ry="2.5" fill="#9c5e21" transform="rotate(18 115 56)" />
      <path d="M116,84 Q108,86 110,94 L120,98 L126,90 Q126,82 116,84 Z" fill="#2E8FA1" transform="rotate(18 118 90)" />
      {/* Crab beside Turbo */}
      <ellipse cx="180" cy="170" rx="14" ry="9" fill="#E0290A" />
      <ellipse cx="180" cy="167" rx="11" ry="4" fill="#f04420" opacity="0.6" />
      <line x1="175" y1="161" x2="175" y2="154" stroke="#E0290A" strokeWidth="2" />
      <line x1="185" y1="161" x2="185" y2="154" stroke="#E0290A" strokeWidth="2" />
      <circle cx="175" cy="152" r="2.5" fill="#F9FCF1" />
      <circle cx="185" cy="152" r="2.5" fill="#F9FCF1" />
      <circle cx="175" cy="152" r="1.5" fill="#131313" />
      <circle cx="185" cy="152" r="1.5" fill="#131313" />
      <ellipse cx="164" cy="168" rx="6" ry="4" fill="#E0290A" />
      <path d="M158,166 Q156,168 158,170 L160,170 L160,168 Z" fill="#E0290A" />
      <path d="M158,170 Q156,172 158,174 L160,174 L160,172 Z" fill="#E0290A" />
      <ellipse cx="196" cy="168" rx="6" ry="4" fill="#E0290A" />
      <path d="M202,166 Q204,168 202,170 L200,170 L200,168 Z" fill="#E0290A" />
      <path d="M202,170 Q204,172 202,174 L200,174 L200,172 Z" fill="#E0290A" />
      <line x1="172" y1="178" x2="168" y2="184" stroke="#E0290A" strokeWidth="2" strokeLinecap="round" />
      <line x1="177" y1="180" x2="175" y2="186" stroke="#E0290A" strokeWidth="2" strokeLinecap="round" />
      <line x1="183" y1="180" x2="185" y2="186" stroke="#E0290A" strokeWidth="2" strokeLinecap="round" />
      <line x1="188" y1="178" x2="192" y2="184" stroke="#E0290A" strokeWidth="2" strokeLinecap="round" />
    </g>
  );
}
